import { cisInstance } from './cis-instance';

/** Подпись */
export const signature = {
    getFileSignature: (id: string): Promise<string> =>
        cisInstance.get<string>(`File/Download?fileDescId=${id}`).then(x => x.data),
    getSignatureInfoSet: (id: string) =>
        cisInstance.get(`File/GetSignatureInfoSet/?key=${id}`).then(x => x.data),
};
